"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.findRuleSetBufferPDA = exports.findRuleSetPDA = void 0;
const web3_js_1 = require("@solana/web3.js");
const mpl_token_auth_rules_1 = require("./mpl-token-auth-rules");
const findRuleSetPDA = async (payer, name) => {
    return await web3_js_1.PublicKey.findProgramAddress([Buffer.from(mpl_token_auth_rules_1.PREFIX), payer.toBuffer(), Buffer.from(name)], mpl_token_auth_rules_1.PROGRAM_ID);
};
exports.findRuleSetPDA = findRuleSetPDA;
const findRuleSetBufferPDA = async (payer, name) => {
    return await web3_js_1.PublicKey.findProgramAddress([Buffer.from(mpl_token_auth_rules_1.PREFIX), payer.toBuffer()], mpl_token_auth_rules_1.PROGRAM_ID);
};
exports.findRuleSetBufferPDA = findRuleSetBufferPDA;
//# sourceMappingURL=pda.js.map